export interface PaysafeBillingCycle {
  endDate: string;
  frequency: number;
}
